// extracted by mini-css-extract-plugin
export default {"buttons":"Pagination_buttons__7HATd"};